import { render, staticRenderFns } from "./MySettings.vue?vue&type=template&id=aaac79e8&scoped=true&"
import script from "./MySettings.vue?vue&type=script&lang=js&"
export * from "./MySettings.vue?vue&type=script&lang=js&"
import style0 from "./MySettings.vue?vue&type=style&index=0&id=aaac79e8&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aaac79e8",
  null
  
)

export default component.exports